import { render } from "./JobsCatalogueDashboard.vue?vue&type=template&id=378536e4&scoped=true"
import script from "./JobsCatalogueDashboard.vue?vue&type=script&lang=js"
export * from "./JobsCatalogueDashboard.vue?vue&type=script&lang=js"

import "./JobsCatalogueDashboard.vue?vue&type=style&index=0&id=378536e4&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-378536e4"]])

export default __exports__